import { APP_LINKS, ORGANIZATION, SITE_NAME, SITE_URL } from "./config";
import { FAQ_ITEMS } from "./faqContent";

export function organizationSchema() {
    return {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: ORGANIZATION.name,
        legalName: ORGANIZATION.legalName,
        url: ORGANIZATION.url,
        logo: ORGANIZATION.logo,
        email: ORGANIZATION.email,
        foundingDate: ORGANIZATION.foundingDate,
        address: {
            "@type": "PostalAddress",
            ...ORGANIZATION.address,
        },
        sameAs: ORGANIZATION.sameAs,
    };
}

export function websiteSchema() {
    return {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: SITE_NAME,
        url: SITE_URL,
        publisher: {
            "@type": "Organization",
            name: ORGANIZATION.name,
            url: ORGANIZATION.url,
        },
        potentialAction: {
            "@type": "SearchAction",
            target: `${SITE_URL}/faqs?q={search_term_string}`,
            "query-input": "required name=search_term_string",
        },
    };
}

export function mobileApplicationSchema() {
    return {
        "@context": "https://schema.org",
        "@type": "MobileApplication",
        name: SITE_NAME,
        operatingSystem: "Android",
        applicationCategory: "FinanceApplication",
        offers: {
            "@type": "Offer",
            price: "0",
            priceCurrency: "INR",
        },
        downloadUrl: APP_LINKS.googlePlay,
        installUrl: APP_LINKS.googlePlay,
        publisher: {
            "@type": "Organization",
            name: ORGANIZATION.name,
        },
    };
}

export function faqPageSchema() {
    return {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: FAQ_ITEMS.map((item) => ({
            "@type": "Question",
            name: item.question,
            acceptedAnswer: {
                "@type": "Answer",
                text: item.answer,
            },
        })),
    };
}

export function breadcrumbSchema(items) {
    return {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: items.map((item, index) => ({
            "@type": "ListItem",
            position: index + 1,
            name: item.name,
            item: item.url,
        })),
    };
}

export function webPageSchema({ title, description, url }) {
    return {
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: title,
        description,
        url,
        isPartOf: {
            "@type": "WebSite",
            name: SITE_NAME,
            url: SITE_URL,
        },
        publisher: {
            "@type": "Organization",
            name: ORGANIZATION.name,
        },
    };
}
